import { requestStatus } from "../../../../../constants";

export const getStatusBaseOnApprover = (item: any, currentUserName: string) => {
  const {
    eApprovedBy,
    eApprovedByITLead,
    eApprovedByITHead,
    eAssignee,
    eRequestStatus,
  } = item;
  if (!eRequestStatus) {
    const approverEmail = eApprovedBy ? eApprovedBy.split("|")[1] : "";
    const approvedByITLeadEmail = eApprovedByITLead
      ? eApprovedByITLead.split("|")[1]
      : "";
    const approvedByITHeadEmail = eApprovedByITHead
      ? eApprovedByITHead.split("|")[1]
      : "";
    const assigneeEmail = eAssignee ? eAssignee.split("|")[1] : "";
    if (currentUserName.toLowerCase() === approverEmail.toLowerCase()) {
      return item.eApprovedStatus || requestStatus.submitted;
    } else if (
      currentUserName.toLowerCase() === approvedByITLeadEmail.toLowerCase()
    ) {
      return item.eApprovedByITLeadStatus || requestStatus.submitted;
    } else if (
      currentUserName.toLowerCase() === approvedByITHeadEmail.toLowerCase()
    ) {
      return item.eApprovedByITHeadStatus || requestStatus.submitted;
    } else if (currentUserName.toLowerCase() === assigneeEmail.toLowerCase()) {
      return item.eAssigneeStatus || requestStatus.submitted;
    }
  } else {
    return eRequestStatus;
  }
};
